import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type ScheduleListActiveIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function ScheduleListActiveIcon({
  className,
  pathClassName = "stroke-white",
  ...props
}: ScheduleListActiveIconProps) {
  return (
    <Svg
      width={28}
      height={28}
      viewBox="0 0 28 28"
      fill="none"
      className={className}
      {...props}
    >
      <Path
        d="M24.055 8.236a5.728 5.728 0 00-1.248-1.843 5.613 5.613 0 00-1.867-1.26 5.939 5.939 0 00-1.33-.373V3.208a.875.875 0 00-1.75 0V4.69h-7.712V3.208a.875.875 0 00-1.75 0V4.76a5.647 5.647 0 00-3.185 1.61 5.705 5.705 0 00-1.68 4.06v9.45c-.002.76.145 1.513.432 2.216.281.7.702 1.335 1.237 1.867.53.542 1.165.97 1.866 1.26a5.683 5.683 0 002.205.443h9.462a5.752 5.752 0 005.728-5.74v-9.461a5.53 5.53 0 00-.408-2.229zm-4.667 11.189H8.69a.875.875 0 010-1.75h10.617a.875.875 0 110 1.75h.081zm0-5.915H8.69a.875.875 0 010-1.75h10.617a.875.875 0 110 1.75h.081z"
        className={pathClassName}
      />
    </Svg>
  );
}

export default ScheduleListActiveIcon;
